import { Col, Form, Input, message, Modal, notification, Row, Switch } from 'antd'
import configuration from 'modules/configuration'
import login from 'modules/login'
import { generateMessageError } from 'modules/core/utils'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

const AzureTenantCreateModal = ({ visible, onClose, onRefetch, createAzureTenant, loggedUser }) => {
  const [isSaving, setIsSaving] = useState(false)
  const [form] = Form.useForm()
  const { t } = useTranslation()

  const onCancel = () => {
    form.resetFields()
    onClose()
  }

  const onConfirm = () => {
    form.validateFields().then((values) => {
      setIsSaving(true)
      // El client se vincula automáticamente a la sociedad del usuario logueado.
      const payload = { ...values, is_active: values.is_active ?? true, client: loggedUser.society_id }
      createAzureTenant(payload)
        .then(() =>
          onRefetch().then(() => {
            message.success(t('FEEDBACK_CHANGES_SAVED_SUCCESS'), 8)
            setIsSaving(false)
            onCancel()
          }),
        )
        .catch((error) => {
          setIsSaving(false)
          onCancel()
          notification.error({
            message: t('FEEDBACK_DEFAULT_ERROR'),
            description: generateMessageError(error),
            duration: 0,
          })
        })
    })
  }

  return (
    <Modal
      title={t('CONFIG_AZURE_TENANT_CREATE_MODAL_TITLE')}
      visible={visible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText={t('ACTION_CREATE')}
      okButtonProps={{ loading: isSaving }}
      cancelButtonProps={{ disabled: isSaving }}
      centered
      forceRender
      destroyOnClose
    >
      <Form form={form} layout="vertical" initialValues={{ is_active: true }}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Form.Item label={t('CONFIG_AZURE_TENANT_FIELD_CLIENT')}>
              <Input value={loggedUser.society} disabled />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={t('CONFIG_AZURE_TENANT_FIELD_NAME')}
              name="name"
              rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
            >
              <Input placeholder={t('CONFIG_AZURE_TENANT_FIELD_NAME')} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={t('CONFIG_AZURE_TENANT_FIELD_TENANT_ID')}
              name="azure_tenant_id"
              rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
            >
              <Input placeholder={t('CONFIG_AZURE_TENANT_FIELD_TENANT_ID')} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={t('CONFIG_AZURE_TENANT_FIELD_ACTIVE')}
              name="is_active"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  loggedUser: login.selectors.getWhoAmI(state),
})

const mapDispatchToProps = {
  createAzureTenant: configuration.actions.createAzureTenant,
}

export default connect(mapStateToProps, mapDispatchToProps)(AzureTenantCreateModal)
